// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"286":"57ddaffe","453":"bf934f4c"}[chunkId] + ".chunk.js";
};